import styled from 'styled-components';
import { Link } from 'gatsby'


export const Content = styled(Link)`
  margin-top: 30px;
  padding: 1.7rem 3.5rem;
`;

export const IconButton = styled.span`
  margin-left: 5px;
  display: flex;
`;
